import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import swal from "sweetalert";
import requests from "./base";

const ActionDropdown = ({ orderId, onStatusUpdated  }) => {
  const [open, setOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");

  const statusOptions = ["Pending", "Processing", "Delivered", "Canceled", "Returned"];

  const handleUpdate = async () => {
    if (!selectedStatus) {
      swal("Error", "Please select a status", "error");
      return;
    }

    try {
      const response = await requests.post(`/updateorderstatusbyid?Id=${orderId}&status=${selectedStatus}`);
       if (response) {
        if (response.ResponseCode === 1) {
         
       
          swal("Success", response.ResponseMessage, "success");
          if (onStatusUpdated) {
    onStatusUpdated(); // refresh table
  }
        }
      }
      else if (response.ResponseCode === 2) {
          swal("Error", response.ResponseMessage, "error");
          // console.warn("Pending approval:", response);
        } else {
          swal("Error", "server error response. Please try again later.", "error");
          console.warn("Unexpected response:", response);
        }
    } catch (error) {
      console.error("Update failed:", error);
      swal("Error", `Failed to update order`, "error");
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <Button  style={{ color: "white", backgroundColor: "Grey" }} onClick={() => setOpen(true)}>
        Update
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Update Order Status</DialogTitle>
        <DialogContent>
          <Typography>Select the new status:</Typography>
          <RadioGroup
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            {statusOptions.map((status) => (
              <FormControlLabel
                key={status}
                value={status}
                control={<Radio />}
                label={status}
              />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} style={{ color: "red", objectFit: "contain" }}>
            Cancel
          </Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActionDropdown;
